import styled from 'styled-components';
import { Popover } from '@sede-enterprise/shell-ds-react-framework';

export { NGContainer } from '../NominationGroups/style';

export const BalanceListWrapper = styled.div`
  /* Shared tracks keep the header aligned with the inline parameter rows. */
  --balance-columns: minmax(0, 1.4fr) minmax(0, 1.8fr) minmax(0, 1fr) minmax(0, 1fr) 64px;

  .balance-inline-header {
    display: grid;
    grid-template-columns: var(--balance-columns);
    gap: 8px;
    font-weight: 600;
    padding: 8px 5px;
  }

  .parameter-inline-editor {
    grid-template-columns: var(--balance-columns);
    align-items: stretch;
  }

  .parameter-inline-editor .parameter-inline-cell {
    display: flex;
    min-width: 0;
  }

  .parameter-inline-editor .parameter-inline-cell > div {
    display: flex;
    width: 100%;
  }

  .parameter-inline-editor .parameter-inline-cell .shell-text-input,
  .parameter-inline-editor .parameter-inline-cell .shell-date-picker,
  .parameter-inline-editor .parameter-inline-cell .balance-entity-select,
  .parameter-inline-editor .parameter-inline-cell .balance-entity-select .shell-select-selector {
    height: 100%;
  }

  .parameter-inline-editor .parameter-inline-actions {
    align-self: end;
  }

  .balance-entity-select .shell-select-item-option-content {
    white-space: normal;
    overflow-wrap: anywhere;
  }
`;

export const ActionMenu = styled(Popover)`
  z-index: 3;
  box-shadow:
    rgba(0, 0, 0, 0.2) 0 2px 5px,
    rgba(0, 0, 0, 0.2) 0 0 2px;
  border: 1px solid rgb(221, 221, 221);
  border-radius: 4px;

  .menu-container {
    display: flex;
    flex-direction: column;
    padding: 3px 5px;

    button {
      margin-top: 2px;
      font-weight: 400;
    }
  }
`;
